import { createRoot } from 'react-dom/client'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import Router from './components/Router'
import config from './config'
import { store } from './redux/store'
import './static/styles.less'

const container = document.getElementById('root')
const root = createRoot(container!)

root.render(
  // <React.StrictMode>
  <GoogleOAuthProvider clientId={config.social.GOOGLE_APP_ID}>
    <Provider store={store}>
      <BrowserRouter basename="/">
        <Router />
      </BrowserRouter>
    </Provider>
  </GoogleOAuthProvider>,
  // </React.StrictMode>,
)
